<template>
  <div class="news-page">
    <div class="page-header">
      <div class="container">
        <h1>新闻动态</h1>
        <div class="breadcrumb">首页 > 新闻动态</div>
      </div>
    </div>
    <div class="container">
      <div class="section">
        <div class="section-title">
          <h2>新闻动态</h2>
          <p>了解我们的最新动态和行业资讯</p>
        </div>
        <div class="news-list">
          <div class="news-item">
            <div class="news-date">
              <span class="day">15</span>
              <span class="month">六月</span>
              <span class="year">2023</span>
            </div>
            <div class="news-content">
              <h3>公司新闻标题示例</h3>
              <p>这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。</p>
              <a href="javascript:;" class="read-more">阅读更多</a>
            </div>
          </div>
          <div class="news-item">
            <div class="news-date">
              <span class="day">10</span>
              <span class="month">五月</span>
              <span class="year">2023</span>
            </div>
            <div class="news-content">
              <h3>行业新闻标题示例</h3>
              <p>这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。这里是新闻内容的简短摘要。</p>
              <a href="javascript:;" class="read-more">阅读更多</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News'
}
</script>

<style scoped lang="scss">
.news-list {
  .news-item {
    display: flex;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    
    &:last-child {
      border-bottom: none;
    }
    
    .news-date {
      flex: 0 0 100px;
      text-align: center;
      padding: 15px;
      background-color: #1ebec8;
      color: white;
      border-radius: 4px;
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      .day {
        font-size: 24px;
        font-weight: bold;
      }
      
      .month, .year {
        font-size: 14px;
      }
    }
    
    .news-content {
      flex: 1;
      
      h3 {
        margin-top: 0;
        margin-bottom: 10px;
        font-size: 20px;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
      }
      
      .read-more {
        color: #1ebec8;
        text-decoration: none;
        font-weight: bold;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style> 